
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutiIgBM7ryicm_ukdwZDPIe_45QrT1i4PnhSMiIotF5AgU8Meta } from "/vercel/path0/frontend/pages/about.vue?macro=true";
import { default as indexf3MmZ7j1r_XwQ2ClnuF6KC_45QOPOLRjGPcnqtzdf6S_45gMeta } from "/vercel/path0/frontend/pages/index.vue?macro=true";
import { default as photo4QcPE9WvIHaDzltsG_45usUy7BTnS87TCwZNvBVvoybR0Meta } from "/vercel/path0/frontend/pages/photo.vue?macro=true";
import { default as videoWzmsddI1lLePY3ABhkVrURoN5_45bYUJe_XQO7BODOxfIMeta } from "/vercel/path0/frontend/pages/video.vue?macro=true";
import { default as indexH5w7D9gLnZoqYct5Yy_O1LDJ9xgbzjSGNe2mGfPDwrcMeta } from "/vercel/path0/frontend/pages/blog/index.vue?macro=true";
import { default as indexyPxyNQc4wmwIBwDMAc6J7ta_45dQwTpy_FkIEmCC3rfuwMeta } from "/vercel/path0/frontend/pages/legal/index.vue?macro=true";
import { default as _91_46_46_46slug_93TWdnC01RQNygHLoLBzP_45eqliEQl8_zHnfS7S0k_45NYPEMeta } from "/vercel/path0/frontend/pages/blog/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_933A04P51S2DQuef09reHlHvPSb2KayjJFRqm_lPQuhFcMeta } from "/vercel/path0/frontend/pages/legal/[...slug].vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/vercel/path0/frontend/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/frontend/pages/index.vue")
  },
  {
    name: "photo",
    path: "/photo",
    component: () => import("/vercel/path0/frontend/pages/photo.vue")
  },
  {
    name: "video",
    path: "/video",
    component: () => import("/vercel/path0/frontend/pages/video.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/vercel/path0/frontend/pages/blog/index.vue")
  },
  {
    name: "legal",
    path: "/legal",
    component: () => import("/vercel/path0/frontend/pages/legal/index.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug(.*)*",
    component: () => import("/vercel/path0/frontend/pages/blog/[...slug].vue")
  },
  {
    name: "legal-slug",
    path: "/legal/:slug(.*)*",
    component: () => import("/vercel/path0/frontend/pages/legal/[...slug].vue")
  }
]